export const category = [
    {value: 'General', label: 'General'},
    {value: 'OBC', label: 'OBC'},
    {value: 'SC', label:'SC'},
    {value: 'ST', label:'ST'}
]